module.exports = __webpack_public_path__ + "img/logo.7f01d8b3.png";